import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { IoClose } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { setbankoffermodal } from "../../redux/formslice";

const Bankoffermodal = ({ plans }) => {
    const dispatch = useDispatch();
    const bankoffermodal = useSelector((state) => state.formslice.bankoffermodal);

    const close = () => {
        dispatch(setbankoffermodal(false));
    };

    const [selectedPlan, setSelectedPlan] = useState(null);

    useEffect(() => {
        if (bankoffermodal && Array.isArray(plans) && plans.length > 0) {
            setSelectedPlan(
                plans.find((p) => p?.description && Object.keys(p.description).length > 0) || plans[0]
            );
        }
    }, [plans, bankoffermodal]);

    const handleSelect = (plan) => {
        setSelectedPlan(plan);
    };

    return (
        <div>
            <Modal show={bankoffermodal} centered size="xl">
                <div className="p-3">
                    <div className="snplmodal">
                        <div className="modalclose d-flex paymentoptionsnpl pe-2 pt-2">
                            <div className="paymentoption-title">
                                <div className="paytitle">ENBD Payment Options</div>
                            </div>
                            <div>
                                <IoClose size={20} className="cursor-pointer" onClick={close} />
                            </div>
                        </div>
                    </div>
                    <div className="bankoffersubtitle">You can pick the EMI plans</div>

                    <div>
                        {Array.isArray(plans) && plans.length > 0 ? (
                            <>
                                <div className="tabs">
                                    {plans.map((plan) => (
                                        <button
                                            key={plan.time_period}
                                            className={`tab-btn text-nowrap ${
                                                selectedPlan?.time_period === plan.time_period ? "active" : ""
                                            }`}
                                            onClick={() => handleSelect(plan)}
                                        >
                                            {plan.time_period}
                                        </button>
                                    ))}
                                </div>

                                {selectedPlan?.description &&
                                Object.keys(selectedPlan.description).length > 0 ? (
                                    <div className="details-box">
                                        <div className="emi-line bankoffercard mb-3">
                                            <span className="bankofferinterst">{selectedPlan.description.interest}</span>
                                            <span className="bankoffercost">{selectedPlan.description.payamount}</span>
                                        </div>
                                        <div className="bankoffercard mb-3">
                                            <div className="details-row pb-3">
                                                <span className="bankoffer-titles">Price</span>
                                                <span className="bankoffercost">
                                                    {selectedPlan.description.price}
                                                </span>
                                            </div>
                                            <div className="details-row pb-3">
                                                <span className="bankoffer-titles">Bank Processing Fees</span>
                                                <span className="bankoffercost">
                                                    {selectedPlan.description.processing_fee}
                                                </span>
                                            </div>
                                            <div className="details-row">
                                                <span className="bankoffer-titles">
                                                    Interest paid to bank ({selectedPlan.description.interest_num})
                                                </span>
                                                <span className="bankoffercost">
                                                    {selectedPlan.description.emi_interest_to_bank}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="total-row bankoffercard">
                                            <span className="bankoffer-totaltitle">
                                                Total Amount Payable ({selectedPlan.description.total_amnt_left})
                                            </span>
                                            <span className="total">
                                                {selectedPlan.description.total_amnt_right}
                                            </span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="no-emi-box">
                                        <h4>No EMI plan available.</h4>
                                        <p>
                                            Explore better plan options –
                                            <br />
                                            the perfect fit is just a click away!
                                        </p>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="no-emi-box">
                                <h4>No EMI plans available.</h4>
                                <p>Please try again later.</p>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Bankoffermodal;
